import { apiModel } from "./api/api-store";
import { dealModel } from "./api/deal-store";
import { aboutModel } from "./api/about-store";
import { licenseModel } from "./api/license-store";
import { managerModel } from "./api/management-store";
import { somethingModel } from "./api/something-store";
import { createStore } from "easy-peasy";
import { popupModel } from "./api/popup-store";
import { bonusModel } from "./api/bonus-store";
import { privilegeModel } from "./api/privilege-store";
import { productionModel } from "./api/production-store";
import { opticaModel } from "./api/optica-store";
import { purchaseModel } from "./api/purchase-store";
import { careerModel } from "./api/career-store";
import { requisiteModel } from "./api/requisite-store";
import { rentModel } from "./api/rent-store";
// import { storeModel } from "./api/store-store";
import { cityIpModel } from "./api/getCIty-store";
import { contactsModel } from "./api/contacts-store";
import { phonesModel } from "./api/phone-store";
import { placeModel } from "./api/place-store";
import { legalModel } from "./api/legal-store";
import { colorModel } from "./api/color-store";
import { frontModel } from "./api/front-store";
import { aboutCardModel } from "./api/aboutCard-store";
import { activeModel } from "./api/active-store";
import { dinamikModel } from "./api/dinamik-store";
import { pathModel } from "./api/path-store";
import { metaModel } from "./api/meta-store";
import { bannerModel } from "./api/banner-store";
import { securityModel } from "./api/security-store";
import { careerPathModel } from "./api/careerPath-store";

export function initiateStore(initial) {
  return createStore(
    {
      api: apiModel,
      about: aboutModel,
      license: licenseModel,
      manager: managerModel,
      something: somethingModel,
      deal: dealModel,
      popup: popupModel,
      bonus: bonusModel,
      privilege: privilegeModel,
      production: productionModel,
      optica: opticaModel,
      purchase: purchaseModel,
      career: careerModel,
      requisite: requisiteModel,
      rent: rentModel,
      // store: storeModel,
      cityIp: cityIpModel,
      contact: contactsModel,
      phone: phonesModel,
      place: placeModel,
      legal: legalModel,
      color: colorModel,
      front: frontModel,
      aboutCard: aboutCardModel,
      active: activeModel,
      dinamik: dinamikModel,
      path: pathModel,
      meta: metaModel,
      banner: bannerModel,
      security: securityModel,
      careerPath: careerPathModel,
    },
    { initialState: initial ? initial : {} }
  );
}
